<template>
  <layout-empty v-if="isEmptyLayout"></layout-empty>
  <layout-main v-else></layout-main>
</template>

<script>
export default {
  name: 'App',
  components: {
    LayoutEmpty: () => import('@/views/LayoutEmpty.vue'),
    LayoutMain: () => import('@/views/LayoutMain.vue')
  },
  data: () => ({
    connected: false
  }),
  sockets: {
    connect() {
      this.connected = true
    }
  },
  created() {
    const $root = this.$root
    document.addEventListener('keydown', e => {
      if (e.code === 'Enter') {
        $root.$emit('keydown:enter')
      } else if (e.code === 'Escape') {
        $root.$emit('keydown:esc')
      }
    })
  },
  computed: {
    isEmptyLayout() {
      return this.$route.meta.emptyLayout === true
    },
    hasToken() {
      return this.$store.getters.IS_LOGIN
    },
    readyToSocketAuth() {
      return this.hasToken && this.connected
    },
    getToken() {
      return this.$store.getters.GET_TOKEN
    }
  },
  watch: {
    readyToSocketAuth() {
      if (this.readyToSocketAuth) {
        this.authInSocket()
      }
    }
  },
  methods: {
    authInSocket() {
      this.$socket.emit(
        'authenticate',
        {
          strategy: 'jwt',
          accessToken: this.getToken
        },
        (error, newAuthResult) => {
          if (!error) {
            this.$store.dispatch('SOCKET_AUTHENTICATE', newAuthResult)
          }
        }
      )
    }
  }
}
</script>
